// copied from SARD, refactor to sard core, eRostering also has own one

import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  static targets = ['input']
  static SELECTORS = 'input[type="date"], input[type="text"][id^="date_"], input[type="text"][id$="_date"], input[type="text"][id*="_date_"]'

  connect() {
    if (document.querySelector('meta[name="pdf"]')) return

    this.#apply()
  }

  disconnect() {
    document.removeEventListener('shown.bs.modal', this.apply)
  }

  #apply() {
    document.querySelectorAll(this.constructor.SELECTORS).forEach(input => {
      flatpickr(input, this.#config(input))
    })

    this.inputTargets.forEach(input_target => {
      flatpickr(input_target, this.#config(input_target))
    })
  }

  #config(input) {
    // need to parse and pass date in given format because field type is date
    let defaultDate = null
    if (input.value) {
      const date = new Date(input.value)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      defaultDate = `${day}/${month}/${year}`
    }

    const config = {
      enableTime: false,
      allowInput: true,
      //altInput: true,
      //altFormat: 'Y-m-d',
      defaultDate: defaultDate,
      dateFormat: 'd/m/Y',
      // disableMobile: true, use native date picker on mobile, default in flatpickr
      locale: {
        firstDayOfWeek: 1
      }
    }

    return config
  }
}
